/*!
 * @tencent/manta-probe-web v1.0.43
 * (c) 2021-2022 upweb
 */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

// 网络类型定义
var NetType;
(function (NetType) {
    NetType[NetType["WIFI"] = 1] = "WIFI";
    NetType[NetType["2G"] = 2] = "2G";
    NetType[NetType["3G"] = 3] = "3G";
    NetType[NetType["4G"] = 4] = "4G";
    NetType[NetType["5G"] = 5] = "5G";
    NetType[NetType["MOBILE"] = 6] = "MOBILE";
    NetType[NetType["ETHERNET"] = 7] = "ETHERNET";
    NetType[NetType["OTHER"] = 8] = "OTHER";
})(NetType || (NetType = {}));
// 事件类型定义
var EventType;
(function (EventType) {
    EventType[EventType["EXPOSE"] = 1001] = "EXPOSE";
    EventType[EventType["CLICK"] = 1002] = "CLICK";
    EventType[EventType["EXIT"] = 1003] = "EXIT";
    EventType[EventType["DELETE"] = 1004] = "DELETE";
    EventType[EventType["ADD"] = 1005] = "ADD";
    EventType[EventType["MOVE"] = 1006] = "MOVE";
})(EventType || (EventType = {}));
// 系统类型定义
var SysId;
(function (SysId) {
    SysId[SysId["ANDROID"] = 1] = "ANDROID";
    SysId[SysId["IOS"] = 2] = "IOS";
    SysId[SysId["PC"] = 3] = "PC";
})(SysId || (SysId = {}));
var ProductId;
(function (ProductId) {
    ProductId[ProductId["XINYUE"] = 1] = "XINYUE";
    ProductId[ProductId["XIAOYUE"] = 2] = "XIAOYUE";
    ProductId[ProductId["SVIP"] = 3] = "SVIP";
    ProductId[ProductId["CIEBA"] = 4] = "CIEBA";
    ProductId[ProductId["HELPER"] = 5] = "HELPER";
})(ProductId || (ProductId = {}));
var DataSource;
(function (DataSource) {
    DataSource[DataSource["NATIVE_APP"] = 1] = "NATIVE_APP";
    DataSource[DataSource["PC"] = 2] = "PC";
    DataSource[DataSource["INSIDE"] = 3] = "INSIDE";
    DataSource[DataSource["WECHART_OFFICIAL_WEBSITE"] = 4] = "WECHART_OFFICIAL_WEBSITE";
    DataSource[DataSource["H5_APP"] = 21] = "H5_APP";
    DataSource[DataSource["H5_MOBILE"] = 12] = "H5_MOBILE";
    DataSource[DataSource["H5_PC"] = 22] = "H5_PC";
    DataSource[DataSource["H5_WX_ACCOUNT"] = 11] = "H5_WX_ACCOUNT";
    DataSource[DataSource["H5_WX_MP"] = 23] = "H5_WX_MP";
    DataSource[DataSource["H5_QQ_ACCOUNT"] = 10] = "H5_QQ_ACCOUNT";
    DataSource[DataSource["H5_QQ_MP"] = 24] = "H5_QQ_MP";
    DataSource[DataSource["OTHER"] = 0] = "OTHER";
})(DataSource || (DataSource = {}));
// 登录类型
var LoginType;
(function (LoginType) {
    LoginType[LoginType["QQ"] = 1] = "QQ";
    LoginType[LoginType["WX"] = 2] = "WX";
    LoginType[LoginType["QC"] = 3] = "QC";
})(LoginType || (LoginType = {}));

var BaseApi = /*@__PURE__*/ (function () {
    // expose?: (element: HTMLBaseElement, message: IMessage) => void;
    function BaseApi(options, Probe) {
        var _this = this;
        var instance = new Probe(options);
        // 暴露通用接口
        this.setConfig = instance.setConfig.bind(instance);
        this.on = instance.on.bind(instance);
        this.flush = instance.reporter.submit.bind(instance.reporter);
        this.createTraceId = instance.createTraceId.bind(instance);
        this.getPublicParams = instance.getPublicParams.bind(instance);
        // 暴露插件接口
        Object.entries(instance.pluginInterface).forEach(function (_a) {
            var name = _a[0], fn = _a[1];
            _this[name] = fn;
        });
    }
    /* eslint-disable @typescript-eslint/naming-convention */
    BaseApi.NET_TYPE = NetType;
    BaseApi.EVENT_TYPE = EventType;
    BaseApi.SYS_ID = SysId;
    BaseApi.PRODUCT_ID = ProductId;
    BaseApi.DATA_SOURCE = DataSource;
    BaseApi.LOGIN_TYPE = LoginType;
    return BaseApi;
}());

function getSize(str) {
    var count = str.length;
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255) {
            count += 1;
        }
    }
    return count;
}
function getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
function getRequestId() {
    var id = '';
    for (var i = 0; i < 16; i++) {
        var code = ((Math.random() * 62) | 0) + 48; // 数字
        code = code > 57 ? code + 7 : code; // 大写字母
        code = code > 90 ? code + 6 : code; // 小写字母
        id += String.fromCharCode(code);
    }
    return id;
}
function deepEqual(x, y) {
    if (x === null || x === undefined || y === null || y === undefined) {
        return x === y;
    }
    if (x === y || x.valueOf() === y.valueOf()) {
        return true;
    }
    if (Array.isArray(x) && x.length !== y.length) {
        return false;
    }
    if ((x instanceof Date && !(y instanceof Date)) || (!(x instanceof Date) && y instanceof Date)) {
        return false;
    }
    if (x instanceof Date && y instanceof Date) {
        return x.valueOf() === y.valueOf();
    }
    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) {
        return false;
    }
    if (!(y instanceof Object)) {
        return false;
    }
    // recursive object equality check
    var p = Object.keys(x);
    return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) && p.every(function (i) { return deepEqual(x[i], y[i]); });
}
/**
 * 从对象中pick需要的字段
 * @param {object} object  原对象
 * @param {string[]} props key值列表
 * @returns {object}
 */
var pick = function (object, props) {
    var newObj = {};
    if (!props) {
        Object.assign(newObj, object);
    }
    else {
        props.forEach(function (key) {
            var _a;
            if (typeof object[key] !== 'undefined') {
                Object.assign(newObj, (_a = {},
                    _a[key] = object[key],
                    _a));
            }
        });
    }
    return newObj;
};

// @ts-nocheck
/* eslint-disable */
/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
var LIBVERSION = '0.7.28', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', // deprecated
MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 255;
///////////
// Helper
//////////
var util = {
    extend: function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
            if (extensions[i] && extensions[i].length % 2 === 0) {
                mergedRegexes[i] = extensions[i].concat(regexes[i]);
            }
            else {
                mergedRegexes[i] = regexes[i];
            }
        }
        return mergedRegexes;
    },
    has: function (str1, str2) {
        return typeof str1 === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
    },
    lowerize: function (str) {
        return str.toLowerCase();
    },
    major: function (version) {
        return typeof (version) === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
    },
    trim: function (str, len) {
        str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        return typeof (len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
    }
};
///////////////
// Map helper
//////////////
var mapper = {
    rgx: function (ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while (i < arrays.length && !matches) {
            var regex = arrays[i], // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while (j < regex.length && !matches) {
                matches = regex[j++].exec(ua);
                if (!!matches) {
                    for (p = 0; p < props.length; p++) {
                        match = matches[++k];
                        q = props[p];
                        // check if given property is actually array
                        if (typeof q === OBJ_TYPE && q.length > 0) {
                            if (q.length == 2) {
                                if (typeof q[1] == FUNC_TYPE) {
                                    // assign modified match
                                    this[q[0]] = q[1].call(this, match);
                                }
                                else {
                                    // assign given value, ignore regex match
                                    this[q[0]] = q[1];
                                }
                            }
                            else if (q.length == 3) {
                                // check whether function or regex
                                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                    // call function (usually string mapper)
                                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                }
                                else {
                                    // sanitize match using given regex
                                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                }
                            }
                            else if (q.length == 4) {
                                this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                            }
                        }
                        else {
                            this[q] = match ? match : undefined;
                        }
                    }
                }
            }
            i += 2;
        }
    },
    str: function (str, map) {
        for (var i in map) {
            // check if array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                for (var j = 0; j < map[i].length; j++) {
                    if (util.has(map[i][j], str)) {
                        return (i === UNKNOWN) ? undefined : i;
                    }
                }
            }
            else if (util.has(map[i], str)) {
                return (i === UNKNOWN) ? undefined : i;
            }
        }
        return str;
    }
};
///////////////
// String map
//////////////
var maps = {
    browser: {
        // Safari < 3.0
        oldSafari: {
            version: {
                '1.0': '/8',
                '1.2': '/1',
                '1.3': '/3',
                '2.0': '/412',
                '2.0.2': '/416',
                '2.0.3': '/417',
                '2.0.4': '/419',
                '?': '/'
            }
        },
        oldEdge: {
            version: {
                '0.1': '12.',
                '21': '13.',
                '31': '14.',
                '39': '15.',
                '41': '16.',
                '42': '17.',
                '44': '18.'
            }
        }
    },
    os: {
        windows: {
            version: {
                'ME': '4.90',
                'NT 3.11': 'NT3.51',
                'NT 4.0': 'NT4.0',
                '2000': 'NT 5.0',
                'XP': ['NT 5.1', 'NT 5.2'],
                'Vista': 'NT 6.0',
                '7': 'NT 6.1',
                '8': 'NT 6.2',
                '8.1': 'NT 6.3',
                '10': ['NT 6.4', 'NT 10.0'],
                'RT': 'ARM'
            }
        }
    }
};
//////////////
// Regex map
/////////////
var regexes = {
    browser: [
    // [
    //     /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
    // ], [VERSION, [NAME, 'Chrome']], [
    //     /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
    // ], [VERSION, [NAME, 'Edge']], [
    //     // breaking change (reserved for next major release):
    //     ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
    //     //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [
    //     // Presto based
    //     /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
    //     /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i,                // Opera Mobi/Tablet
    //     /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i,                         // Opera
    // ], [NAME, VERSION], [
    //     /opios[\/\s]+([\w\.]+)/i                                            // Opera mini on iphone >= 8.0
    // ], [VERSION, [NAME, 'Opera Mini']], [
    //     /\sopr\/([\w\.]+)/i                                                 // Opera Webkit
    // ], [VERSION, [NAME, 'Opera']], [
    //     // Mixed
    //     /(kindle)\/([\w\.]+)/i,                                             // Kindle
    //     /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,     // Lunascape/Maxthon/Netfront/Jasmine/Blazer
    //     // Trident based
    //     /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
    //     /(ba?idubrowser)[\/\s]?([\w\.]+)/i,                                 // Baidu Browser
    //     /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
    //     // Webkit/KHTML based
    //     /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i,
    //     // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
    //     /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i,         // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
    //     /(weibo)__([\d\.]+)/i                                               // Weibo
    // ], [NAME, VERSION], [
    //     /(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i           // UCBrowser
    // ], [VERSION, [NAME, 'UCBrowser']], [
    //     /(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i      // WeChat Desktop for Windows Built-in Browser
    // ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
    //     /micromessenger\/([\w\.]+)/i                                        // WeChat
    // ], [VERSION, [NAME, 'WeChat']], [
    //     /konqueror\/([\w\.]+)/i                                             // Konqueror
    // ], [VERSION, [NAME, 'Konqueror']], [
    //     /trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i                     // IE11
    // ], [VERSION, [NAME, 'IE']], [
    //     /yabrowser\/([\w\.]+)/i                                             // Yandex
    // ], [VERSION, [NAME, 'Yandex']], [
    //     /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
    // ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [
    //     /focus\/([\w\.]+)/i                                                 // Firefox Focus
    // ], [VERSION, [NAME, 'Firefox Focus']], [
    //     /opt\/([\w\.]+)/i                                                   // Opera Touch
    // ], [VERSION, [NAME, 'Opera Touch']], [
    //     /coc_coc_browser\/([\w\.]+)/i                                       // Coc Coc Browser
    // ], [VERSION, [NAME, 'Coc Coc']], [
    //     /dolfin\/([\w\.]+)/i                                                // Dolphin
    // ], [VERSION, [NAME, 'Dolphin']], [
    //     /coast\/([\w\.]+)/i                                                 // Opera Coast
    // ], [VERSION, [NAME, 'Opera Coast']],
    // [/xiaomi\/miuibrowser\/([\w\.]+)/i                                  // MIUI Browser
    // ], [VERSION, [NAME, 'MIUI Browser']], [
    //     /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
    // ], [VERSION, [NAME, 'Firefox']], [
    //     /(qihu|qhbrowser|qihoobrowser|360browser)/i                         // 360
    // ], [[NAME, '360 Browser']], [
    //     /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
    // ], [[NAME, /(.+)/, '$1 Browser'], VERSION], [                       // Oculus/Samsung/Sailfish Browser
    //     /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
    // ], [[NAME, /_/g, ' '], VERSION], [
    //     /\s(electron)\/([\w\.]+)\ssafari/i,                                 // Electron-based App
    //     /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i,                // Tesla
    //     /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i           // QQBrowser/Baidu App/2345 Browser
    // ], [NAME, VERSION], [
    //     /(MetaSr)[\/\s]?([\w\.]+)/i,                                        // SouGouBrowser
    //     /(LBBROWSER)/i                                                      // LieBao Browser
    // ], [NAME], [
    //     // WebView
    //     /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android with version
    // ], [VERSION, [NAME, 'Facebook']], [
    //     /FBAN\/FBIOS|FB_IAB\/FB4A/i                                         // Facebook App for iOS & Android without version
    // ], [[NAME, 'Facebook']], [
    //     /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
    //     /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
    //     /(chromium|instagram)[\/\s]([\w\.-]+)/i                             // Chromium/Instagram
    // ], [NAME, VERSION], [
    //     /\bgsa\/([\w\.]+)\s.*safari\//i                                     // Google Search Appliance on iOS
    // ], [VERSION, [NAME, 'GSA']], [
    //     /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
    // ], [VERSION, [NAME, 'Chrome Headless']], [
    //     /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
    // ], [[NAME, 'Chrome WebView'], VERSION], [
    //     /droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i         // Android Browser
    // ], [VERSION, [NAME, 'Android Browser']], [
    //     /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i      // Chrome/OmniWeb/Arora/Tizen/Nokia
    // ], [NAME, VERSION], [
    //     /version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i                      // Mobile Safari
    // ], [VERSION, [NAME, 'Mobile Safari']], [
    //     /version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i                   // Safari & Safari Mobile
    // ], [VERSION, NAME], [
    //     /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
    // ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [
    //     /(webkit|khtml)\/([\w\.]+)/i
    // ], [NAME, VERSION], [
    //     // Gecko based
    //     /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
    // ], [[NAME, 'Netscape'], VERSION], [
    //     /ile\svr;\srv:([\w\.]+)\).+firefox/i                                // Firefox Reality
    // ], [VERSION, [NAME, 'Firefox Reality']], [
    //     /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
    //     /(swiftfox)/i,                                                      // Swiftfox
    //     /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
    //     // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
    //     /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
    //     // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
    //     /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,                       // Other Firefox-based
    //     /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,                        // Mozilla
    //     // Other
    //     /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
    //     // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
    //     /(links)\s\(([\w\.]+)/i,                                            // Links
    //     /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
    //     /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
    //     /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
    // ], [NAME, VERSION]
    ],
    cpu: [
    // [
    //     /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
    // ], [[ARCHITECTURE, 'amd64']], [
    //     /(ia32(?=;))/i                                                      // IA32 (quicktime)
    // ], [[ARCHITECTURE, util.lowerize]], [
    //     /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
    // ], [[ARCHITECTURE, 'ia32']], [
    //     /\b(aarch64|armv?8e?l?)\b/i                                         // ARM64
    // ], [[ARCHITECTURE, 'arm64']], [
    //     /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
    // ], [[ARCHITECTURE, 'armhf']], [
    //     // PocketPC mistakenly identified as PowerPC
    //     /windows\s(ce|mobile);\sppc;/i
    // ], [[ARCHITECTURE, 'arm']], [
    //     /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
    // ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
    //     /(sun4\w)[;\)]/i                                                    // SPARC
    // ], [[ARCHITECTURE, 'sparc']], [
    //     /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
    //     // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    // ], [[ARCHITECTURE, util.lowerize]]
    ],
    device: [[
            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i
        ], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i,
            /\ssamsung[\s-]([\w-]+)/i,
            /sec-(sgh\w+)/i
        ], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            // Apple
            /\((ip(?:hone|od)[\s\w]*);/i // iPod/iPhone
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
            /\((ipad);[\w\s\),;-]+apple/i,
            /applecoremedia\/[\w\.]+\s\((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
            // Huawei
            /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i,
        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [
            /d\/huawei([\w\s-]+)[;\)]/i,
            /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i,
            /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i
        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
            // Xiaomi
            /\b(poco[\s\w]+)(?:\sbuild|\))/i,
            /\b;\s(\w+)\sbuild\/hm\1/i,
            /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,
            /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i,
            /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i // Xiaomi Mi
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i // Mi Pad tablets
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            // OPPO
            /;\s(\w+)\sbuild.+\soppo/i,
            /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
        ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
            // Vivo
            /\svivo\s(\w+)(?:\sbuild|\))/i,
            /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i
        ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [
            // Realme
            /\s(rmx[12]\d{3})(?:\sbuild|;)/i
        ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [
            // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i,
            /\smot(?:orola)?[\s-](\w*)/i,
            /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i
        ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
        ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
            // LG
            /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i
        ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /(lm-?f100[nv]?|nexus\s[45])/i,
            /lg[e;\s\/-]+((?!browser|netcast)\w+)/i,
            /\blg(\-?[\d\w]+)\sbuild/i
        ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
            // Lenovo
            /(ideatab[\w\-\s]+)/i,
            /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i // Lenovo tablets
        ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            // Nokia
            /(?:maemo|nokia).*(n900|lumia\s\d+)/i,
            /nokia[\s_-]?([\w\.-]*)/i
        ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [
            // Google
            /droid.+;\s(pixel\sc)[\s)]/i // Google Pixel C
        ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
            /droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i // Google Pixel
        ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [
            // Sony
            /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /sony\stablet\s[ps]\sbuild\//i,
            /(?:sony)?sgp\w+(?:\sbuild\/|\))/i
        ], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [
            // OnePlus
            /\s(kb2005|in20[12]5|be20[12][59])\b/i,
            /\ba000(1)\sbuild/i,
            /\boneplus\s(a\d{4})[\s)]/i
        ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)(\sbuild\/|\))/i,
            /(kf[a-z]+)(\sbuild\/|\)).+silk\//i // Kindle Fire HD
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i // Fire Phone
        ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            // BlackBerry
            /\((playbook);[\w\s\),;-]+(rim)/i // BlackBerry PlayBook
        ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10;\s(\w+)/i // BlackBerry 10
        ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
            // Asus
            /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i
        ], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [
            /\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i
        ], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [
            // HTC
            /(nexus\s9)/i // HTC Nexus 9
        ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,
            // ZTE
            /(zte)-(\w*)/i,
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
            // Acer
            /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
        ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
            // Meizu
            /droid.+;\s(m[1-5]\snote)\sbuild/i,
            /\bmz-([\w-]{2,})/i
        ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,
            /(asus)-?(\w+)/i,
            /(microsoft);\s(lumia[\s\w]+)/i,
            /(lenovo)[_\s-]?([\w-]+)/i,
            /linux;.+(jolla);/i,
            /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(archos)\s(gamepad2?)/i,
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            /(kindle)\/([\w\.]+)/i,
            /\s(nook)[\w\s]+build\/(\w+)/i,
            /(dell)\s(strea[kpr\s\d]*[\dko])/i,
            /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i,
            /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i,
            /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i,
            /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i // Vodafone
        ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /\s(surface\sduo)\s/i // Surface Duo
        ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [
            /droid\s[\d\.]+;\s(fp\du?)\sbuild/i
        ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /\s(u304aa)\sbuild/i // AT&T
        ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /sie-(\w*)/i // Siemens
        ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /[;\/]\s?(rct\w+)\sbuild/i // RCA Tablets
        ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /[;\/\s](venue[\d\s]{2,7})\sbuild/i // Dell Venue Tablets
        ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i // Verizon Tablet
        ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i // Barnes & Noble Tablet
        ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /[;\/]\s(tm\d{3}\w+)\sbuild/i
        ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /;\s(k88)\sbuild/i // ZTE K Series Tablet
        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /;\s(nx\d{3}j)\sbuild/i // ZTE Nubia
        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /[;\/]\s?(gen\d{3})\sbuild.*49h/i // Swiss GEN Mobile
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /[;\/]\s?(zur\d{3})\sbuild/i // Swiss ZUR Tablet
        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /[;\/]\s?((zeki)?tb.*\b)\sbuild/i // Zeki Tablets
        ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /[;\/]\s([yr]\d{2})\sbuild/i,
            /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i // Dragon Touch Tablet
        ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /[;\/]\s?(ns-?\w{0,9})\sbuild/i // Insignia Tablets
        ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i // NextBook Tablets
        ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i
        ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i // LvTel Phones
        ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /;\s(ph-1)\s/i
        ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i // Envizen Tablets
        ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i // MachSpeed Tablets
        ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /[;\/]\s?tu_(1491)\sbuild/i // Rotor Tablets
        ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w\s]+)\sbuild/i // Nvidia Shield Tablets
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint)\s(\w+)/i // Sprint Phones
        ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i // Microsoft Kin
        ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
            /droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
        ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [
            /droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i
        ], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [
            ///////////////////
            // CONSOLES
            ///////////////////
            /\s(ouya)\s/i,
            /(nintendo)\s([wids3utch]+)/i // Nintendo
        ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+;\s(shield)\sbuild/i // Nvidia
        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation\s[345portablevi]+)/i // Playstation
        ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
            /[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i // Microsoft Xbox
        ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i // Samsung
        ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
        ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
            /(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i, // LG SmartTV
        ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [
            /(apple)\s?tv/i // Apple TV
        ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [
            /crkey/i // Google Chromecast
        ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [
            /droid.+aft([\w])(\sbuild\/|\))/i // Fire TV
        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i // Sharp
        ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
        ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
            /[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i // SmartTV from Unidentified Vendors
        ], [[TYPE, SMARTTV]], [
            ///////////////////
            // WEARABLES
            ///////////////////
            /((pebble))app\/[\d\.]+\s/i // Pebble
        ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+;\s(glass)\s\d/i // Google Glass
        ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
            /droid\s[\d\.]+;\s(wt63?0{2,3})\)/i
        ], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i // Tesla
        ], [VENDOR, [TYPE, EMBEDDED]], [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i // Android Phones from Unidentified Vendors
        ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
        ], [MODEL, [TYPE, TABLET]], [
            /\s(tablet|tab)[;\/]/i,
            /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
        ], [[TYPE, util.lowerize]], [
            /(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
        ], [MODEL, [VENDOR, 'Generic']], [
            /(phone)/i
        ], [[TYPE, MOBILE]]
    ],
    engine: [
    // [
    //     /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
    // ], [VERSION, [NAME, 'EdgeHTML']], [
    //     /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
    // ], [VERSION, [NAME, 'Blink']], [
    //     /(presto)\/([\w\.]+)/i,                                             // Presto
    //     /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
    //     /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
    //     /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
    //     /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
    // ], [NAME, VERSION], [
    //     /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
    // ], [VERSION, NAME]
    ],
    os: [[
            // Windows
            /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
        ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i
        ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
        ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,
            /cfnetwork\/.+darwin/i
        ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i // Mac OS
        ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
            // Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,
            /(tizen|kaios)[\/\s]([\w\.]+)/i,
            /\((series40);/i // Series 40
        ], [NAME, VERSION], [
            /\(bb(10);/i // BlackBerry 10
        ], [VERSION, [NAME, 'BlackBerry']], [
            /(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i // Symbian
        ], [VERSION, [NAME, 'Symbian']], [
            /mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
        ], [[NAME, 'Firefox OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
        ], [VERSION, [NAME, 'webOS']], [
            // Google Chromecast
            /crkey\/([\d\.]+)/i // Google Chromecast
        ], [VERSION, [NAME, 'Chromecast']], [
            /(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
        ], [[NAME, 'Chromium OS'], VERSION], [
            // Console
            /(nintendo|playstation)\s([wids345portablevuch]+)/i,
            /(xbox);\s+xbox\s([^\);]+)/i,
            // GNU/Linux based
            /(mint)[\/\s\(\)]?(\w*)/i,
            /(mageia|vectorlinux)[;\s]/i,
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i,
            // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
            // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,
            /(gnu)\s?([\w\.]*)/i,
            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            /(haiku)\s(\w+)/i // Haiku
        ], [NAME, VERSION], [
            // Other
            /(sunos)\s?([\w\.\d]*)/i // Solaris
        ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
            /(unix)\s?([\w\.]*)/i // UNIX
        ], [NAME, VERSION]
    ]
};
/////////////////
// Constructor
////////////////
var UAParser = function (ua, extensions) {
    if (typeof ua === 'object') {
        extensions = ua;
        ua = undefined;
    }
    if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
    }
    var _ua = ua || ((typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
    var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
    this.getBrowser = function () {
        var _browser = { name: undefined, version: undefined };
        mapper.rgx.call(_browser, _ua, _rgxmap.browser);
        _browser.major = util.major(_browser.version); // deprecated
        return _browser;
    };
    this.getCPU = function () {
        var _cpu = { architecture: undefined };
        mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
    };
    this.getDevice = function () {
        var _device = { vendor: undefined, model: undefined, type: undefined };
        mapper.rgx.call(_device, _ua, _rgxmap.device);
        return _device;
    };
    this.getEngine = function () {
        var _engine = { name: undefined, version: undefined };
        mapper.rgx.call(_engine, _ua, _rgxmap.engine);
        return _engine;
    };
    this.getOS = function () {
        var _os = { name: undefined, version: undefined };
        mapper.rgx.call(_os, _ua, _rgxmap.os);
        return _os;
    };
    this.getResult = function () {
        return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
        };
    };
    this.getUA = function () {
        return _ua;
    };
    this.setUA = function (ua) {
        _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? util.trim(ua, UA_MAX_LENGTH) : ua;
        return this;
    };
    this.setUA(_ua);
    return this;
};
UAParser.VERSION = LIBVERSION;
UAParser.BROWSER = {
    NAME: NAME,
    MAJOR: MAJOR,
    VERSION: VERSION
};
UAParser.CPU = {
    ARCHITECTURE: ARCHITECTURE
};
UAParser.DEVICE = {
    MODEL: MODEL,
    VENDOR: VENDOR,
    TYPE: TYPE,
    CONSOLE: CONSOLE,
    MOBILE: MOBILE,
    SMARTTV: SMARTTV,
    TABLET: TABLET,
    WEARABLE: WEARABLE,
    EMBEDDED: EMBEDDED
};
UAParser.ENGINE = {
    NAME: NAME,
    VERSION: VERSION
};
UAParser.OS = {
    NAME: NAME,
    VERSION: VERSION
};

var version = "1.0.43";

var ua = navigator.userAgent;
var isIOS = function () { return /iPad|iPhone|iPod/i.test(ua); }; // ios
var isAndroid = function () { return /android/i.test(ua); }; // 安卓
var isQQ = function () { return ua.match(/QQ\/[0-9]/i); };
// 获取电量
// const getPowerLevel = async (): Promise<number> => {
//   let battery;
//   // @ts-ignore
//   if (navigator.getBattery) {
//     // @ts-ignore
//     battery = await navigator.getBattery();
//   } else {
//     // @ts-ignore
//     battery = navigator.battery || navigator.webkitBattery || navigator.mozBattery;
//   }
//   return battery?.level || 1;
// };
// 尝试从本地获取uuid
var getLocalUUID = function () {
    var storeKey = 'probe-uuid';
    var uuid = localStorage.getItem(storeKey);
    if (!uuid) {
        uuid = getUUID();
        localStorage.setItem(storeKey, uuid);
    }
    return uuid;
};
var getSessionUUID = function () {
    var storeKey = 'probe-session-uuid';
    var uuid = sessionStorage.getItem(storeKey);
    if (!uuid) {
        uuid = getUUID();
        sessionStorage.setItem(storeKey, uuid);
    }
    return uuid;
};
var getNettype = function () {
    // @ts-ignore: Unreachable code error
    var conn = (navigator === null || navigator === void 0 ? void 0 : navigator.connection) || {};
    // @ts-ignore: Unreachable code error
    var type = (conn.type || conn.effectiveType || 'other').toUpperCase();
    return NetType[type] || NetType.OTHER;
};
var getUrlQueries = function () {
    var hashQuerystring = window.location.hash.indexOf('?') > 0 ? location.hash.replace(/^.*?\?/, '') : '';
    var querystring = window.location.search.slice(1);
    var queries = "".concat(hashQuerystring, "&").concat(querystring).split('&').reduce(function (q, str) {
        var _a;
        if (str && str.indexOf('=') > 0) {
            var item = str.split('=');
            Object.assign(q, (_a = {}, _a[item[0]] = item[1], _a));
        }
        return q;
    }, {});
    return queries;
};
// 自动提取login_type
var getLoginType = function () {
    var loginTypeKey = getCookie('acctype') || getCookie('login_type') || getCookie('xyapp_login_type') || '';
    // @ts-ignore-next-line
    return loginTypeKey ? LoginType[loginTypeKey.toUpperCase()] : void 0;
};
// 自动提取cus_uin
var getCusUin = function (loginType) {
    if (loginType !== 1) {
        return getCookie('openid');
    }
    // 处理o0开头的uin
    return (getCookie('uin') || '').replace(/^o0*(\d+)$/, '$1');
};
var getPublicParams = function () {
    // @ts-ignore
    var uaParser = new UAParser();
    var device = uaParser.getDevice();
    var os = uaParser.getOS();
    var queries = getUrlQueries();
    var uuid = getLocalUUID();
    var ua = navigator.userAgent;
    var sysid = SysId.PC;
    if (isAndroid())
        sysid = SysId.ANDROID;
    if (isIOS())
        sysid = SysId.IOS;
    var netType = getNettype();
    var loginType = getLoginType();
    return {
        sys_id: sysid,
        net_type: netType,
        useragent: ua,
        uuid: uuid,
        sdkVersion: version,
        sessionid_h5: getSessionUUID(),
        sessionid_app: getCookie('app_sessionid_app') || void 0,
        mac_id: getCookie('app_mac_id') || void 0,
        device_id: getCookie('app_device_id') || uuid,
        idfa: getCookie('app_idfa') || void 0,
        sysver_name: os.name,
        sysver_code: os.version,
        brand: device.vendor,
        model: device.model,
        cus_uin: getCusUin(loginType) || void 0,
        cus_appid: getCookie('appid') || void 0,
        login_type: loginType,
        via: queries.via || getCookie('app_via') || 'other',
        via_source: queries.via_source || getCookie('app_via_source') || void 0,
        trace_id: queries.trace_id || void 0,
    };
};
var getParams = function () {
    // const powerLever = await getPowerLevel();
    var powerLever = 0; // 用不上，暂时置为0
    return {
        url: location.href,
        event_time: new Date().getTime(),
        // params: location.search.replace(/^\?/, ''),
        referrer: document.referrer,
        phone_power: powerLever,
    };
};
var getCookie = function (cname) {
    var name = "".concat(cname, "=");
    var ca = document.cookie.split(';');
    var found = ca.find(function (item) { return item.trim().indexOf(name) === 0; });
    if (found)
        return found.trim().substring(name.length, found.length);
    return '';
};

if (!Object.entries) {
  Object.entries = function(obj){
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i);
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
  };
}

var BaseProbe = /*@__PURE__*/ (function () {
    function BaseProbe(options) {
        this.pluginInterface = {};
        this.installedPlugins = new Set();
        this.subscriptionEvents = [];
        this.requestId = '';
        if (!options.publicParams) {
            console.error('manta-probe: "options.publicParams" is missing or not valid.');
        }
        else if (!options.publicParams.product_id) {
            console.error('manta-probe: "options.publicParams.product_id" is missing or not valid.');
        }
        this.options = options;
    }
    BaseProbe.prototype.init = function (_a) {
        var reporter = _a.reporter, queue = _a.queue;
        this.queue = queue;
        this.reporter = reporter;
    };
    /**
     * 动态修改配置
     * @param options 配置项
     */
    BaseProbe.prototype.setConfig = function (options) {
        this.options = __assign(__assign({}, this.options), options);
        this.emit('config', options);
    };
    BaseProbe.prototype.setupPlugin = function (plugins) {
        var _this = this;
        plugins.forEach(function (_a) {
            var plugin = _a[0], options = _a[1];
            if (_this.installedPlugins.has(plugin.name)) {
                console.warn("manta-probe: '".concat(plugin.name, "' is already installed."));
            }
            try {
                plugin(_this, options);
                _this.installedPlugins.add(plugin.name);
            }
            catch (err) {
                console.warn("manta-probe: '".concat(plugin.name, "' initialization failed."));
            }
        });
    };
    /**
     * 订阅事件
     * @param name 事件名
     * @param fn   事件回调
     */
    BaseProbe.prototype.on = function (name, fn) {
        this.subscriptionEvents.push({
            name: name,
            fn: fn,
        });
    };
    /**
     * 发布事件
     * @param name  事件名
     * @param event 事件内容
     */
    BaseProbe.prototype.emit = function (name, event) {
        var events = this.subscriptionEvents.filter(function (s) { return s.name === name; });
        events.map(function (_a) {
            var fn = _a.fn;
            return fn(event);
        });
    };
    /**
     * 暴露插件接口
     * 当插件需要向外暴露接口时可用此方法
     * 例如埋点插件需要对外暴露点击事件埋点方法：
     * > // plugins/pointEvent/index.js
     * > probe.expose('trackClick', this.pointClickReport);
     *
     * > // 用户方custom.js调用
     * > probe.trackClick({埋点数据})
     * @param {string}    name 方法名
     * @param {function}  fn   具体方法
     */
    BaseProbe.prototype.expose = function (name, fn) {
        if (this.pluginInterface[name]) {
            throw new Error("manta-probe: The interface '".concat(name, "' already exists."));
        }
        this.pluginInterface[name] = fn;
    };
    // 生成traceId
    BaseProbe.prototype.createTraceId = function (prefix, postfix) {
        if (!this.requestId) {
            this.requestId = getRequestId();
        }
        return "".concat(prefix, "-").concat(this.requestId, "-").concat(postfix);
    };
    // 获取公共参数
    BaseProbe.prototype.getPublicParams = function () {
        try {
            return Object.freeze(Object.assign({}, this.reporter.pubData));
        }
        catch (_a) {
            return null;
        }
    };
    return BaseProbe;
}());

var ChunkState;
(function (ChunkState) {
    ChunkState[ChunkState["canWrite"] = 0] = "canWrite";
    ChunkState[ChunkState["ready"] = 1] = "ready";
    ChunkState[ChunkState["popped"] = 2] = "popped";
    ChunkState[ChunkState["readyDel"] = 3] = "readyDel";
})(ChunkState || (ChunkState = {}));
var chunkEvents = [
    { from: ChunkState.canWrite, to: ChunkState.ready },
    { from: ChunkState.canWrite, to: ChunkState.popped },
    { from: ChunkState.ready, to: ChunkState.popped },
    { from: ChunkState.popped, to: ChunkState.readyDel },
];
var AStateMachine = /*@__PURE__*/ (function () {
    function AStateMachine(events) {
        this.events = events;
    }
    AStateMachine.prototype.trans = function (to, cb) {
        var _this = this;
        var arg = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            arg[_i - 2] = arguments[_i];
        }
        if (this.currentState === to ||
            this.events.find(function (_a) {
                var from = _a.from, canTo = _a.to;
                return from === _this.currentState && canTo === to;
            })) {
            var oriState = this.currentState;
            this.currentState = to;
            cb === null || cb === void 0 ? void 0 : cb.call.apply(cb, __spreadArray([this, oriState, to], arg, false));
            return true;
        }
        return false;
    };
    AStateMachine.prototype.is = function (state) {
        return this.currentState === state;
    };
    return AStateMachine;
}());
var AWrapedChunck = /*@__PURE__*/ (function (_super) {
    __extends(AWrapedChunck, _super);
    function AWrapedChunck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = getUUID();
        _this.chunk = '';
        return _this;
    }
    AWrapedChunck.prototype.isEmpty = function () {
        return !!this.chunk;
    };
    return AWrapedChunck;
}(AStateMachine));
var defaultOptions = {
    maxSize: 65536,
    retryTimes: 20,
    bufferSize: 100,
};
var WrapedChunk = /*@__PURE__*/ (function (_super) {
    __extends(WrapedChunk, _super);
    function WrapedChunk(options, bizOpts) {
        var _this = _super.call(this, chunkEvents) || this;
        _this.options = defaultOptions;
        _this.size = 0;
        _this.big = false;
        _this.retryTimes = 0;
        _this.options = __assign(__assign({}, _this.options), options);
        _this.currentState = ChunkState.canWrite;
        var pub = bizOpts.pub, bizKeys = bizOpts.bizKeys;
        _this.chunkValue = {
            pub: pub,
            keys: bizKeys,
            biz: [],
        };
        _this.chunk = JSON.stringify(_this.chunkValue);
        _this.size = getSize(_this.chunk);
        return _this;
    }
    WrapedChunk.prototype.push = function (msg) {
        var _a, _b, _c;
        var msgStr = "".concat(this.isEmpty() ? '' : ',').concat(JSON.stringify(msg));
        var msgSize = getSize(msgStr); // 增量大小，包括value和一个逗号大小
        // 当前chunk容量不足放入消息
        if (msgSize > ((_a = this.options) === null || _a === void 0 ? void 0 : _a.maxSize) - this.size) {
            // 超过单个消息超过chunk容量上限且当前chunk不为空，另起一个chunk
            if (this.isEmpty()) {
                return !!this.writeIn(msg, msgSize, true);
            }
            this.trans(ChunkState.ready);
            return false;
        }
        this.writeIn(msg, msgSize);
        if (((_b = this.options) === null || _b === void 0 ? void 0 : _b.maxSize) - this.size < ((_c = this.options) === null || _c === void 0 ? void 0 : _c.bufferSize)) {
            this.trans(ChunkState.ready);
        }
        return true;
    };
    WrapedChunk.prototype.isEmpty = function () {
        return !this.chunkValue.biz.length;
    };
    WrapedChunk.prototype.pop = function () {
        this.trans(ChunkState.popped);
        this.retryTimes += 1;
        if (this.retryTimes > this.options.retryTimes) {
            this.trans(ChunkState.readyDel);
        }
        return {
            id: this.id,
            chunk: this.chunk,
            big: this.big,
        };
    };
    WrapedChunk.prototype.getId = function () {
        return this.id;
    };
    WrapedChunk.prototype.writeIn = function (msg, msgSize, big) {
        if (big === void 0) { big = false; }
        this.chunkValue.biz.push(msg);
        this.size += msgSize;
        this.big = big;
        this.chunk = JSON.stringify(this.chunkValue);
        return msgSize;
    };
    return WrapedChunk;
}(AWrapedChunck));
var Queue = /*@__PURE__*/ (function () {
    function Queue(options) {
        this.options = options;
        this.chunkList = [];
    }
    Queue.prototype.init = function (pub, bizKeys) {
        this.chunkList.filter(function (chunk) { return chunk.is(ChunkState.canWrite); }).forEach(function (chunk) { return chunk.trans(ChunkState.ready); });
        this.pub = pub;
        this.bizKeys = bizKeys;
    };
    Queue.prototype.add = function (message) {
        if (!this.pub || !this.bizKeys) {
            throw new Error('Please init before add message!');
        }
        var chunk = this.chunkList.find(function (chunk) { return chunk.is(ChunkState.canWrite); });
        try {
            var msgVaules = this.bizKeys.map(function (key) { return message[key]; });
            if (!chunk || !chunk.push(msgVaules)) {
                chunk = new WrapedChunk(this.options, { pub: this.pub, bizKeys: this.bizKeys });
                chunk.push(msgVaules);
                this.chunkList.push(chunk);
            }
        }
        catch (error) {
            throw new Error('Error occure while stringfy to json');
        }
    };
    Queue.prototype.pop = function (opts) {
        var chunk = null;
        chunk = this.chunkList.find(function (chunk) { return chunk.is(ChunkState.ready); });
        if (!chunk && (opts === null || opts === void 0 ? void 0 : opts.historical)) {
            chunk = this.chunkList.find(function (chunk) { return chunk.is(ChunkState.popped); });
        }
        if (!chunk && (opts === null || opts === void 0 ? void 0 : opts.force)) {
            chunk = this.chunkList.find(function (chunk) { return chunk.is(ChunkState.canWrite); });
        }
        return chunk === null || chunk === void 0 ? void 0 : chunk.pop();
    };
    Queue.prototype.popAll = function (opts) {
        var chunks = this.chunkList.filter(function (chunk) {
            return chunk.is(ChunkState.ready) ||
                ((opts === null || opts === void 0 ? void 0 : opts.historical) && chunk.is(ChunkState.popped)) ||
                ((opts === null || opts === void 0 ? void 0 : opts.force) && chunk.is(ChunkState.canWrite));
        }) || [];
        return chunks.map(function (chunk) { return chunk.pop(); });
    };
    Queue.prototype.del = function (chunks) {
        if (!Array.isArray(chunks)) {
            // eslint-disable-next-line no-param-reassign
            chunks = [chunks];
        }
        var idSet = new Set(chunks.map(function (chunk) { return chunk.id; }));
        var readyDelChunks = this.chunkList.filter(function (wrapedChunk) { return idSet.has(wrapedChunk.getId()); });
        readyDelChunks.forEach(function (wrapedChunk) { return wrapedChunk.trans(ChunkState.readyDel); });
        this.chunkList = this.chunkList.filter(function (wrapedChunk) { return !wrapedChunk.is(ChunkState.readyDel); });
    };
    return Queue;
}());
var QueueFactory = /*@__PURE__*/ (function () {
    function QueueFactory() {
    }
    QueueFactory.getInstance = function () {
        return QueueFactory._ins;
    };
    QueueFactory.prototype.createQueue = function (options) {
        return new Queue(options);
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    QueueFactory._ins = new QueueFactory();
    return QueueFactory;
}());
var Queue$1 = QueueFactory.getInstance();

// 应当自动获取的公共参数
var AUTO_PUBLIC_KEYS = [
    'sys_id',
    'net_type',
    'useragent',
    'uuid',
    'sessionid_h5',
    'sessionid_app',
    'mac_id',
    'device_id',
    'idfa',
    'upload_time',
    'sdkVersion',
    'brand',
    'model',
    'sysver_code',
    'sysver_name',
    'via',
    'via_source',
];
// 不可修改的公共参数，必须在初始化时提供
var IMMUTABLE_PUBLIC_KEYS = ['product_id', 'version', 'business_id', 'data_source'];
// 可动态修改的公共参数
var MUTABLE_PUBLIC_KEYS = ['cookie_id', 'cus_uin', 'cus_appid', 'gopenid', 'gappid', 'login_type', 'trace_id'];
var BaseReporter = /*@__PURE__*/ (function () {
    function BaseReporter(probe) {
        var _this = this;
        this.probe = probe;
        var defaultReportUrl = probe.options.env === 'test'
            ? 'https://report.upweb.qq.com/release/v2.0/beacon-test'
            : 'https://report.upweb.qq.com/release/v1.0/beacon';
        this.reportUrl = probe.options.reportUrl || defaultReportUrl;
        this.keys = [];
        var publicParams = pick(probe.options.publicParams || {}, __spreadArray(__spreadArray([], IMMUTABLE_PUBLIC_KEYS, true), MUTABLE_PUBLIC_KEYS, true));
        this.pubData = Object.assign({
            product_id: [],
            business_id: '',
            data_source: DataSource.OTHER,
            upload_time: new Date().getTime(),
        }, publicParams);
        this.changedPubData = {};
        // 定时上报
        setInterval(function () {
            _this.submit();
        }, 5000);
        probe.on('config', this.changeConfig.bind(this));
    }
    // 修改配置
    BaseReporter.prototype.changeConfig = function (event) {
        if (event.reportUrl) {
            this.reportUrl = event.reportUrl;
        }
        // 修改公共参数
        var cusPublicParams = pick(event || {}, MUTABLE_PUBLIC_KEYS);
        Object.assign(this.changedPubData, cusPublicParams);
    };
    // 压入数据
    BaseReporter.prototype.push = function (message) {
        var _this = this;
        var _a;
        if (!((_a = message === null || message === void 0 ? void 0 : message.event) === null || _a === void 0 ? void 0 : _a.data_id)) {
            console.warn('manta-probe: "data_id" is missing or not valid.');
        }
        var isNeedInitQueue = false;
        // 处理公共数据
        var cusPublicParams = pick(message.public || {}, __spreadArray(__spreadArray([], AUTO_PUBLIC_KEYS, true), MUTABLE_PUBLIC_KEYS, true));
        var newPubData = Object.assign({}, this.pubData, cusPublicParams, this.changedPubData);
        if (!deepEqual(this.pubData, newPubData)) {
            // 修正cus_uin
            if (newPubData.cus_uin && newPubData.cus_uin.indexOf('o') === 0) {
                newPubData.cus_uin = newPubData.cus_uin.replace(/^o0*(\d+)$/, '$1');
            }
            // 修正login_type
            if (typeof newPubData.login_type === 'string' && isNaN(newPubData.login_type)) {
                console.warn("manta-probe: \"login_type=".concat(newPubData.login_type, "\" is not valid."));
            }
            Object.assign(this.pubData, newPubData);
            isNeedInitQueue = true;
        }
        // 执行beforeReport钩子
        if (this.probe.options.beforeReport) {
            var cusEvent = this.probe.options.beforeReport(__assign({}, message.event));
            Object.assign(message.event, cusEvent);
        }
        // 处理keys
        var keys = Object.keys(message.event);
        keys.forEach(function (key) {
            if (!_this.keys.some(function (p) { return p === key; })) {
                _this.keys.push(key);
                isNeedInitQueue = true;
            }
        });
        if (isNeedInitQueue) {
            this.probe.queue.init(this.pubData, this.keys);
        }
        // 处理ext字段
        if (typeof message.event.ext === 'object') {
            // eslint-disable-next-line no-param-reassign
            message.event.ext = JSON.stringify(message.event.ext);
        }
        this.probe.queue.add(message.event);
        // 立即上报
        if (this.probe.options.alwaysFlush) {
            this.submit();
        }
    };
    // 上报数据
    BaseReporter.prototype.submit = function (historical) {
        var _this = this;
        if (historical === void 0) { historical = false; }
        var uploadTimePatt = /("upload_time"):\s?\d+\b/;
        var chunks = this.probe.queue.popAll({ force: true, historical: historical });
        chunks.forEach(function (chunk) { return __awaiter(_this, void 0, void 0, function () {
            var data, uploadTime, isSuccess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!chunk.chunk || typeof chunk.chunk !== 'string')
                            return [2 /*return*/];
                        data = chunk.chunk;
                        uploadTime = new Date().getTime();
                        data = data.replace(uploadTimePatt, "$1:".concat(uploadTime));
                        return [4 /*yield*/, this.send(data)];
                    case 1:
                        isSuccess = _a.sent();
                        if (isSuccess) {
                            this.probe.queue.del(chunk);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return BaseReporter;
}());

var Reporter = /*@__PURE__*/ (function (_super) {
    __extends(Reporter, _super);
    function Reporter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldForceXhr = function () { return isIOS() && isQQ(); };
        return _this;
    }
    Reporter.prototype.send = function (message) {
        var _this = this;
        if (!message) {
            return Promise.resolve(false);
        }
        var sendBeaconRes = navigator.sendBeacon && !this.shouldForceXhr() ? navigator.sendBeacon(this.reportUrl, message) : false;
        if (sendBeaconRes) {
            return Promise.resolve(true);
        }
        return new Promise(function (resolve) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', _this.reportUrl, true);
            xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            xhr.onload = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                }
            };
            xhr.onerror = function () {
                resolve(false);
            };
            xhr.send(message);
        });
    };
    return Reporter;
}(BaseReporter));

var Probe = /*@__PURE__*/ (function (_super) {
    __extends(Probe, _super);
    function Probe(options) {
        var _this = _super.call(this, options) || this;
        _this.init({
            queue: Queue$1.createQueue({}),
            reporter: new Reporter(_this),
        });
        _this.setupPlugin(_this.options.plugins || []);
        // 强制下一个tick才触发ready，防止用户端调用时出现未初始化意外
        setTimeout(function () { return _this.emit('ready', null); }, 0);
        // 卸载页面时立即提交数据
        window.addEventListener('beforeunload', function () { return _this.reporter.submit(); });
        return _this;
    }
    Probe.prototype.report = function (message) {
        var params = getParams();
        var data = {
            public: getPublicParams(),
            event: __assign(__assign({ staytime: 0 }, params), message),
        };
        this.reporter.push(data);
        // 没有sendBeacon时，立即上报，降低漏报率
        if (!navigator.sendBeacon) {
            this.reporter.submit();
        }
    };
    return Probe;
}(BaseProbe));

var MantaProbe = /*@__PURE__*/ (function (_super) {
    __extends(MantaProbe, _super);
    function MantaProbe(options) {
        var _this = _super.call(this, options, Probe) || this;
        // 覆盖默认getPublicParams，主动提取公共参数
        var oldGetPublicParams = _this.getPublicParams;
        _this.getPublicParams = function () { return (__assign(__assign({}, getPublicParams()), oldGetPublicParams())); };
        return _this;
    }
    return MantaProbe;
}(BaseApi));

export { MantaProbe as default };
